export default __webpack_public_path__ + "static/media/round_animation.f9af6bd7.gif";